export default __webpack_public_path__ + "static/media/p1.83658d1d.jpg";